/**
 * Custom hook for managing image preloading
 */
import { useCallback, useEffect } from 'react';
import runWhenIdle from '../utils/runWhenIdle';

export const useImagePreloader = () => {
  const preloadImages = useCallback((urls) => {
    return new Promise((resolve) => {
      let loaded = 0;
      const total = urls.length;

      if (total === 0) {
        resolve();
        return;
      }

      urls.forEach((src) => {
        const img = new Image();
        img.onload = img.onerror = () => {
          loaded += 1;
          if (loaded === total) {
            resolve();
          }
        };
        img.src = src;
      });
    });
  }, []);

  const preloadGameImages = useCallback(
    (games) => {
      runWhenIdle(() => {
        games.forEach((game) => {
          const imageUrls = [
            game.image,
            game.logo,
            ...game.packs.map(([src]) => src),
          ];
          preloadImages(imageUrls);
        });
      });
    },
    [preloadImages],
  );

  return { preloadImages, preloadGameImages };
};
